import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useProductUnitShow () {
  const api = useApi()
  const loading = ref(true)
  const productUnit = ref<ProductUnit>()

  const getData = async (code: string, params?: Record<string, unknown>) => {
    try {
      productUnit.value = await api.GET(`/product-unit/${code}`, params)
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    productUnit,
  }
}
